import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@icon/milestoneIcon.svg'
import _imports_1 from '@icon/goal-complete.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-37d50310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-pic is-green" }
const _hoisted_2 = { class: "notification-title-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  key: 0,
  className: "notification__update-item__content"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    projectName: _ctx.notification.projectName,
    showSubTitle: false,
    class: "notification__item"
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.notification.percentComplete !== 100)
          ? (_openBlock(), _createBlock(_component_icon, {
              key: 0,
              data: _imports_0,
              class: "label-pic__icon",
              width: "var(--icon-24)",
              height: "var(--icon-24)"
            }))
          : (_openBlock(), _createBlock(_component_icon, {
              key: 1,
              data: _imports_1,
              class: "label-pic__icon",
              width: "var(--icon-24)",
              height: "var(--icon-24)"
            }))
      ])
    ]),
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseSubHeading, {
          size: "large",
          color: "monochrome-06",
          darkColor: "monochrome-03",
          weight: "500"
        }, {
          default: _withCtx(() => [
            (_ctx.notification.percentComplete !== 100)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Goal closed ")
                ], 64))
              : (_ctx.notification.milestone && _ctx.notification.percentComplete === 100)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Milestone reached, "),
                    _hoisted_3,
                    _createTextVNode("Goal achieved! ")
                  ], 64))
                : (!_ctx.notification.milestone && _ctx.notification.percentComplete === 100)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" Roadmap Goal Achieved! ")
                    ], 64))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSubHeading, {
          size: "small",
          color: "monochrome-05",
          darkColor: "monochrome-04",
          weight: "500",
          class: "project-setcion"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.notification.projectName), 1)
          ]),
          _: 1
        })
      ])
    ]),
    content: _withCtx(() => [
      (_ctx.notification.milestone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              href: _ctx.notification.mileStoneurl,
              class: "link is-medium-500",
              target: "_blank"
            }, _toDisplayString(_ctx.notification.milestoneName), 9, _hoisted_5),
            _createVNode(_component_BaseSubHeading, {
              size: "medium",
              color: "monochrome-07",
              weight: "500",
              className: "body-text-medium-500 milestone-date"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.notification.milestoneDate), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.notification.content.totalItemsCount)
        ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
            key: 1,
            size: "medium",
            color: "monochrome-07",
            weight: "500",
            className: "body-text-medium-500"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.notification.totalItemsCount) + " Items, " + _toDisplayString(_ctx.notification.percentComplete) + "% Done ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.notification.percentComplete !== 100 || _ctx.notification.milestone)
        ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
            key: 2,
            size: "medium",
            color: "monochrome-06",
            darkColor: "monochrome-03",
            weight: "400",
            class: "curent-goal-text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.notification.currentGoalContent), 1)
            ]),
            _: 1
          }))
        : (_ctx.notification.percentComplete === 100 && !_ctx.notification.milestone)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "link is-medium-500 curent-goal-text",
              target: "_blank",
              href: _ctx.notification.goalUrl
            }, _toDisplayString(_ctx.notification.currentGoalContent), 9, _hoisted_6))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["notification", "projectName"]))
}